import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from '@mui/material';

import { PropertyKey } from '../../../propertyMetadata';

interface Props {
  selectedColumnKeys: readonly PropertyKey[];
  onChange: (visibleColumns: readonly PropertyKey[]) => void;
}

class ColumnsDropdown extends React.Component<Props> {
  onOptionClicked(columnKey: PropertyKey) {
    const newVisibleColumns = this.props.selectedColumnKeys.includes(columnKey)
      ? this.props.selectedColumnKeys.filter((key) => key !== columnKey)
      : this.props.selectedColumnKeys.concat(columnKey);
    this.props.onChange(newVisibleColumns);
  }

  render() {
    return (
      <Accordion sx={{ bgcolor: 'backContrast.main' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography>Columns to Show</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('numberOfDesigns')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="numberOfDesigns"
                  color="primary"
                />
              }
              label="# Designs"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('assignedTo')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="assignedTo"
                  color="primary"
                />
              }
              label="Assigned To"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('createdTimestamp')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="createdTimestamp"
                  color="primary"
                />
              }
              label="Created At"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('creator')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="creator"
                  color="primary"
                />
              }
              label="Creator"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('organizationOwnedBy')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="organizationOwnedBy"
                  color="primary"
                />
              }
              label="Customer"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('jobType')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="jobType"
                  color="primary"
                />
              }
              label="Job Type"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('billingLocation')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="billingLocation"
                  color="primary"
                />
              }
              label="Location"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('openedBy')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="openedBy"
                  color="primary"
                />
              }
              label="Opened By"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('jobPriority')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="jobPriority"
                  color="primary"
                />
              }
              label="Priority"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('regions')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="regions"
                  color="primary"
                />
              }
              label="Regions"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('sharedWithOrganizations')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="sharedWithOrganizations"
                  color="primary"
                />
              }
              label="Shared With"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.selectedColumnKeys.includes('jobStatus')}
                  onChange={(event) => {
                    this.onOptionClicked(event.target.name as PropertyKey);
                  }}
                  name="jobStatus"
                  color="primary"
                />
              }
              label="Status"
            />
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default ColumnsDropdown;
